class ModuleSidebarProfilBirthday {

  private toggle: HTMLInputElement;
  private shareBirthday!: HTMLDivElement;
  private notshareBirthday!: HTMLDivElement;
  private sideBar!: HTMLDivElement;
  private closeButtons!: NodeListOf<Element>;
  private rgpd!: HTMLInputElement;
  private acceptButton!: HTMLButtonElement;

  constructor() {
    this.toggle = document.querySelector(
      '[data-open-sidebar-profil-birthday]'
    ) as HTMLInputElement;

    if (this.toggle) {
      this.shareBirthday = document.querySelector('.share-birthday') as HTMLDivElement;
      this.notshareBirthday = document.querySelector('.not-share-birthday') as HTMLDivElement;
      this.sideBar = document.getElementById('sidebar-profil-birthday') as HTMLDivElement
      this.closeButtons = document.querySelectorAll('[data-close-sidebar-profil-birthday]') as NodeListOf<Element>;
      this.rgpd = document.querySelector('[data-rgpd-sidebar-profil-birthday]') as HTMLInputElement
      this.acceptButton = document.querySelector('[data-valid-sidebar-profil-birthday]') as HTMLButtonElement
      this._init();
    }
  }

  _init() {

    // Toggle de la checkbox
    this.toggle.addEventListener('click', () => {
      if (this.toggle.checked) {
        // Ouverture de la sidebar
        this._toggleSidebar();
      } else {
        this._setShareBirthday(false)
      }
    });

    // Case RGPD
    this.rgpd.addEventListener('change', () => {
      this.acceptButton.disabled = !this.rgpd.checked;
    })

    // Validation
    this.acceptButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.rgpd.checked) {
        this._setShareBirthday(true);
      }
    })

    // Fermeture de la sidebar
    if (this.closeButtons) {
      this.closeButtons.forEach((close) => {
        close.addEventListener('click', this._hideSidebar.bind(this));
      });
    }
  }

  _toggleSidebar() {
    if (this.sideBar) {
      this.sideBar.classList.toggle('open');
      if (this.sideBar.classList.contains('open')) {
        this.rgpd.checked = false
        this.acceptButton.disabled = true;
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    if (this.sideBar && this.sideBar.classList.contains('open')) {
      // Retour à l'ancien état
      this.toggle.checked = !this.toggle.checked;
      if (this.toggle.checked) {
        this.shareBirthday.classList.remove('hidden')
        this.notshareBirthday.classList.add('hidden')
      } else {
        this.shareBirthday.classList.add('hidden')
        this.notshareBirthday.classList.remove('hidden')
      }
      this.sideBar.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }

  async _setShareBirthday(share: boolean) {
    const formData = new FormData();
    formData.append("action", "user_share_birthday");
    formData.append("nonce", (window as any).ajax.nonce);
    formData.append("share", share ? 'true' : 'false');


    try {
      const response = await fetch((window as any).ajax.ajax_url, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        if (share == true) {
          this.shareBirthday.classList.remove('hidden')
          this.notshareBirthday.classList.add('hidden')
        } else {
          this.shareBirthday.classList.add('hidden')
          this.notshareBirthday.classList.remove('hidden')
        }
        this.sideBar.classList.remove('open');
        document.body.classList.remove('sidebar-open');
      } else {
        this.toggle.checked = !share;
        console.error("Erreur lors de la suppression :", result.data);
      }
    } catch (error) {
      console.error("Erreur réseau ou serveur :", error);
    }
  }
}

export const moduleSidebarProfilBirthday = new ModuleSidebarProfilBirthday();
